<template>
  <div class="bottom_main">
    <div class="btm_top">
      <div class="btm_code_item" style="float: none; width: auto;">
        <!-- <img class="btm_code_img" src="/static/img/wx_gzh.jpg" alt=""> -->
        <div>
          官方公众号
        </div>
      </div>
      <!-- <div class="btm_code_item" style="display: none;">
        <!-- <img class="btm_code_img" src="/static/img/douyin.jpg" alt=""> -->
        <div>
          官方抖音
        </div>
      </div> -->
      <div style="clear: left;"></div>
    </div>
    <div class="btm_url">
      <router-link to="/ys">隐私权保护政策</router-link>
      <span class="btm_xx">|</span>
      <router-link to="/xy">用户协议</router-link>
      <span class="btm_xx">|</span>
      <router-link to="/jz">家长监护</router-link>
      <span class="btm_xx">|</span>
      <router-link to="/service">客服中心</router-link>
      <span class="btm_xx">|</span>
      <router-link to="/us">关于我们</router-link>
    </div>
    <div class="btm_comps">
      <br>
      运营单位：<span style="color: #ddd;">{{company.main}} {{company.mainEN}}</span><br>
      办公地址： {{company.address}}<br>
      电话：{{company.telephone}} 邮编：{{company.Postcode}}<br>
      {{company.wangwen}} {{company.appBei}}<br>
      {{company.banhao}}<br>
      <a href="https://beian.miit.gov.cn" target="_blank" style="color: #999;">{{company.IPC}}</a><br><br>
      抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防上当受骗<br>
      适度游戏益脑，沉迷游戏伤身，合理安排时间，享受健康生活<br>
      <br>
    </div>
    <div style="color: rgb(147, 147, 147);">
      中宣部游戏备案号：{{company.zhongxuanbu}}
    </div>
    <div style="width:300px;margin:0 auto; padding:6px 0; display: none;">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37021302000818" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="@/assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">{{company.gonganBeian}}</p>
      </a>
    </div>
    <div class="btm_url" style="padding-bottom: 20px; line-height: 1.2rem;">
      <div class="youqing_title">友情链接</div>
      <a href="http://www.nppa.gov.cn/" target="_blank" class="link_a">国家新闻出版广电总局</a>
      <span class="btm_xx">|</span>
      <a href="https://www.mct.gov.cn/" target="_blank" class="link_a">中华人民共和国文化和旅游部</a>
      <br>
    </div>
    <div class="btm_code_div" v-show="isShowCode" @click="onHideCode">
      <div class="btm_code_d">
        <div class="btm_code_show">
          <div style="font-weight: bold;">微信公众号</div>
          <div>
            <img src="@/assets/gzh_ewm.jpg" alt="">
          </div>
          <div>搜索并关注：“无悠网络”</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import tools from '@/tools/tools'

export default {
  name: 'BottomMobile',
  data: () => {
    return {
      isShowCode: false
    }
  },
  methods: {
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    onShowCode () {
      this.isShowCode = true
    },
    onHideCode () {
      this.isShowCode = false
    }
  },
  computed: {
    company () {
      return this.$store.state.configs.company
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.youqing_title {
  color: #ddd;
}
.link_a:hover {
  color: #3c7cec;
}
.youqing_title {
  margin: 0.5rem;
}
.btm_code_item {
  float: left;
  width: 50%;
}
.btm_code_img {
  width: 6rem;
}
.bottom_main {
  background: rgb(35, 35, 35);
  padding: 1rem 0;
  padding-top: 0;
}
.btm_img {
  width: 2rem;
}
.btm_top {
  font-size: 0.7rem;
  background: #fff;
  padding: 0 3rem;
  padding-bottom: 1rem;
}
.btm_top_s {
  margin-left: 0.3rem;
  position: relative;
  top: -0.6rem;
}
.btm_url {
  margin-top: 1rem;
  color: #bbb;
  font-size: 0.7rem;
}
.btm_url a {
  color: #ddd;
  text-decoration: none;
}
.btm_xx {
  padding: 0 0.3rem;
}
.btm_comps {
  color: #999;
  font-size: 0.6rem;
}
.btm_code_div {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
  background: rgba(0,0,0,0.5);
}
.btm_code_d {
  margin-top: 60%;
  font-size: 0.7rem;
}
.btm_code_show {
  width: 50%;
  margin: auto;
  background: #fff;
  border: 0.5rem #ddd solid;
  border-radius: 0.5rem;
  padding: 0.4rem;
}
</style>
